/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnneeFormationSuivieIfapmeFichierDto
 */
export interface AnneeFormationSuivieIfapmeFichierDto {
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierDto
     */
    idanneeFormationSuivieIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierDto
     */
    idanneeFormationSuivieIfapme?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieIfapmeFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieIfapmeFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieIfapmeFichierDto interface.
 */
export function instanceOfAnneeFormationSuivieIfapmeFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieIfapmeFichierDtoFromJSON(json: any): AnneeFormationSuivieIfapmeFichierDto {
    return AnneeFormationSuivieIfapmeFichierDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieIfapmeFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieIfapmeFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeFormationSuivieIfapmeFichier': !exists(json, 'idanneeFormationSuivieIfapmeFichier') ? undefined : json['idanneeFormationSuivieIfapmeFichier'],
        'idanneeFormationSuivieIfapme': !exists(json, 'idanneeFormationSuivieIfapme') ? undefined : json['idanneeFormationSuivieIfapme'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function AnneeFormationSuivieIfapmeFichierDtoToJSON(value?: AnneeFormationSuivieIfapmeFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeFormationSuivieIfapmeFichier': value.idanneeFormationSuivieIfapmeFichier,
        'idanneeFormationSuivieIfapme': value.idanneeFormationSuivieIfapme,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

